import styled from 'styled-components';

export const Video = styled.video`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
